import React from "react";
import { FooterStyle } from "./style";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <FooterStyle id="contact">
      <div className="info">
        <h4>&reg; 1978 - Lavanderia e Tinturaria Valentim Negri</h4>
        <p>Feito por: <Link to="https://github.com/Tuviccfp">Victor Cordeiro</Link></p>
      </div>
    </FooterStyle>
  );
}
